function Email() {
  return (
    <svg width="11" height="8" viewBox="0 0 11 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.5 6.125C5.16797 6.125 4.83594 6.02734 4.5625 5.8125L0.5 2.64844V7.0625C0.5 7.58984 0.910156 8 1.4375 8H9.5625C10.0703 8 10.5 7.58984 10.5 7.0625V2.64844L6.41797 5.8125C6.14453 6.02734 5.8125 6.125 5.5 6.125ZM0.8125 2.10156L4.95312 5.32422C5.26562 5.55859 5.71484 5.55859 6.02734 5.32422L10.168 2.10156C10.3633 1.94531 10.5 1.69141 10.5 1.4375C10.5 0.929688 10.0703 0.5 9.5625 0.5H1.4375C0.910156 0.5 0.5 0.929688 0.5 1.4375C0.5 1.69141 0.617188 1.94531 0.8125 2.10156Z"
        fill="#FFBF17"
      />
    </svg>
  );
}

export default Email;
